import { GraphQLFieldConfig, GraphQLNonNull, GraphQLString } from 'graphql'
import { Context } from '../shared'
import { libraryClassUsageItemType } from '../types/library-usage'

export interface LibraryUsageItemQueryArgs {
  readonly libraryHash: string
  readonly applicationID: string
  readonly name: string
}

export const libraryUsageItem: GraphQLFieldConfig<
  any,
  Context,
  LibraryUsageItemQueryArgs
> = {
  description: 'Get a library usage item from the Apollo cache',
  type: new GraphQLNonNull(libraryClassUsageItemType),
  args: {
    libraryHash: {
      description: 'The library hash for the class usage item',
      type: new GraphQLNonNull(GraphQLString)
    },
    applicationID: {
      description: 'The application ID for the class usage item',
      type: new GraphQLNonNull(GraphQLString)
    },
    name: {
      description: 'The name of the class/file',
      type: new GraphQLNonNull(GraphQLString)
    }
  }
}
